import React, { useState, useRef } from "react";
import styled from "styled-components";
import emailjs from "@emailjs/browser";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import GmailIcon from "@mui/icons-material/Email";
import SkypeIcon from "@mui/icons-material/AlternateEmail";
import SkypeImage from "../../images/skype.png";
import { Bio } from "../../data/constants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  @media (max-width: 960px) {
    padding: 0px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1350px;
  padding: 0px 0px 80px 0px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #4f9856;
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 16px;
  }
`;

const AdditionalContent = styled.div`
  font-size: 16px;
  color: #e0e0e0;
  margin-top: 20px;
  text-align: center;
`;
const SocialMediaIcons = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 50px; /* Điều chỉnh khoảng cách giữa các icon */
  justify-content: center; 
  align-items: center;
`;


const SocialMediaIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px; /* Đặt kích thước thống nhất cho tất cả các icon */
  height: 50px;
  font-size: 3rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;

  & > svg,
  img {
    width: 100%;
    height: 100%;
    object-fit: contain; /* Đảm bảo icon và hình ảnh không bị méo */
  }
`;

const Contact = () => {
  const [open, setOpen] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [error, setError] = useState(false);
  const form = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.current) {
      emailjs
        .sendForm(
          "service_96fr8xl",
          "template_jaa5ahb",
          form.current,
          "A9jMkHC_a46XIMT0k"
        )
        .then(
          (response) => {
            form.current.reset();
            console.log("SUCCESS!", response.status, response.text);
            setOpen(true);
          },
          (err) => {
            console.log("FAILED...", err);
            setErrorText(err.text);
            setError(true);
          }
        );
    }
  };

  return (
    <Container id="Contact">
      <Wrapper>
        <Title>How to use the service and contact ?</Title>
        <Desc>
          We hope to find customer partners and experience a wonderful
          streamlined experience together. We will wholeheartedly support you
          24/7
        </Desc>
        <Desc>
          <span style={{ color: "#4f9856", marginLeft: "10px" }}>
            ⭐Gmail: {""}
          </span>
          <a
            style={{ color: "#c2ae70" }}
            href="https://mail.google.com/mail/?view=cm&fs=1&to=huylak2212@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            huylak2212@gmail.com
          </a>
          <span style={{ color: "#2596be" }}>⭐Telegram: {""}</span>
          <a
            style={{ color: "#c2ae70" }}
            href="https://t.me/lakky_agency"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://t.me/lakky_agency
          </a>
          <span style={{ color: "#4f9856", marginLeft: "10px" }}>
            ⭐WhatsApp: {""}
          </span>
          <a
            style={{ color: "#c2ae70" }}
            href="https://wa.me/84335015932"
            target="_blank"
            rel="noopener noreferrer"
          >
            +84335015932
          </a>
          <span style={{ color: "#2596be" }}>⭐Skype: {""}</span>
          <a
            style={{ color: "#c2ae70" }}
            href="#"
            target="_blank"
            rel="noopener noreferrer"
          >
            live:.cid.4a5c7884f6feedb
          </a>
        </Desc>
        {/* Additional content added here */}
        {/* <AdditionalContent>
          <span style={{ color: "#e4da64" }}>
            ⭐Lakky Agency Meta ⭐my service click here:{" "}
          </span>
          <a
            style={{ color: "#1abc9c" }}
            href="https://www.blackhatworld.com/seo/welcome-new-customers-from-bhw-with-a-10-day-trial-program-advertising-account-rental-service-fee-from-4-7-divide-final-payment-threshold-50-50.1627217/#post-18043131"
            target="_blank"
            rel="noopener noreferrer"
          >
            support types of advertising Meta accounts - Advertising account
            rental fee from 4-7%
          </a>
          <br />
          <span style={{ color: "#1abc9c" }}>
            Limit 250$ - 1500$ - Unlimited - overcome difficult professions:
            casino, lending, crypto,... ✅
          </span>
          <br />
          <span>
            <span style={{ color: "#2596be" }}>⭐Telegram: {""}</span>
            <a
              style={{ color: "#c2ae70" }}
              href="https://t.me/lakky_agency"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://t.me/lakky_agency
            </a>
            <span style={{ color: "#4f9856", marginLeft: "10px" }}>
              ⭐WhatsApp: {""}
            </span>
            <a
              style={{ color: "#c2ae70" }}
              href="https://wa.me/84335015932"
              target="_blank"
              rel="noopener noreferrer"
            >
              +84335015932
            </a>
          </span>
        </AdditionalContent> */}
        <SocialMediaIcons>
          <SocialMediaIcon
            href={Bio.resume}
            target="display"
            title="Telegram: https://t.me/lakky_agency"
          >
            <TelegramIcon />
          </SocialMediaIcon>
          <SocialMediaIcon
            href={Bio.whatsap}
            target="display"
            title="WhatsApp: +84335015932"
          >
            <WhatsAppIcon />
          </SocialMediaIcon>
          <SocialMediaIcon
            href={Bio.skype}
            target="display"
            title="Skype: https://anotepad.com/notes/i7wh3gt6"
          >
            <img
              src={SkypeImage}
              alt="Skype"
              style={{ width: "40px", height: "40px" }}
            />
          </SocialMediaIcon>
          <SocialMediaIcon
            href={Bio.email}
            target="display"
            title="Gmail: huylak2212@gmail.com"
          >
            <GmailIcon />
          </SocialMediaIcon>
        </SocialMediaIcons>
      </Wrapper>
    </Container>
  );
};

export default Contact;
